import { render, staticRenderFns } from "./ObjectLocation.vue?vue&type=template&id=e3fe2c58&"
import script from "./ObjectLocation.vue?vue&type=script&lang=js&"
export * from "./ObjectLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports